
import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import InputFieldMixin from '~/components/Inputs/InputFieldMixin';

@Component
export default class HiddenInput extends mixins(InputFieldMixin) {
  @Prop({ default: () => [] }) readonly rules!: Array<() => boolean | string>;

  @Prop(Boolean) readonly pasteDisabled!: boolean;

  @Prop({ default: () => ({}) }) readonly mask!: Record<string, unknown>;

  @Prop(Boolean) readonly unmaskOnFocus!: boolean;

  showValue = false;

  isFocused = false;

  defaultDataTestAttr = 'hiddenInput';

  defaultLabelAttr = 'Hidden Input';

  private defaultMask = {
    showMaskOnHover: false,
    noValuePatching: true,
    alias: 'hiddenInput',
    mask: '99999999999999999999',
    jitMasking: true,
    autoUnmask: true,
    onBeforePaste: this.onPaste,
  };

  get inputMask(): Record<string, unknown> {
    return { ...this.defaultMask, ...this.mask };
  }

  get mergedRules() {
    return [this.isRequired, ...this.rules];
  }

  get inputType(): string {
    if (this.showValue || (this.unmaskOnFocus && this.isFocused)) {
      return 'text';
    }

    return 'password';
  }

  validate() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (this.$refs.input as any).validate();
  }

  created() {
    // The `noValuePatching` option causes the input to lose the mask when
    // it's being edited, ie. when there is a value present before applying
    // the mask.
    if (!this.$attrs.value) this.defaultMask.noValuePatching = true;
  }

  private onPaste(pastedValue: string): string | boolean {
    if (this.pasteDisabled) return false;
    return pastedValue;
  }
}
